import { computed } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { useRouteParams } from "@vueuse/router";
import { useExperienceRawApi } from "@/composables/useExperienceRawApi";
import type { RawSnapshot } from "@/types/generated/ExperienceRawServiceApi";

export const RAW_SNAPSHOTS_QUERY_KEY = "raw-snapshots";

export interface RawSnapshotsData {
  rawSnapshot: RawSnapshot | undefined;
  publishedRawSnapshot: RawSnapshot | undefined;
  hasUnpublishedChanges: boolean;
}

export function useCurrentRawSnapshotsQuery() {
  const experienceId = useRouteParams<string>("id");
  const experienceRawApi = useExperienceRawApi();

  return useQuery({
    queryKey: [RAW_SNAPSHOTS_QUERY_KEY, experienceId],
    queryFn: async (): Promise<RawSnapshotsData> => {
      const [{ data: rawSnapshot }, { data: publishedRawSnapshot }] = await Promise.all([
        experienceRawApi.getMostRecentRawSnapshot(experienceId.value),
        experienceRawApi.getMostRecentPublishedRawSnapshot(experienceId.value),
      ]);

      return {
        rawSnapshot,
        publishedRawSnapshot,
        hasUnpublishedChanges: !!publishedRawSnapshot && rawSnapshot?.raw?.status_code !== "UP_TO_DATE",
      };
    },
    enabled: computed(() => !!experienceId.value),
  });
}
